/*
 * Add JavaScript modules below
 */
import App from "./app";

import navigation from "./partials/navigation";
import content from "./partials/content";
import heroFade from "./partials/hero-fade";
import formatHeroTagline from "./partials/format-hero-tagline";
import search from "./partials/search";
import controls from "./partials/controls";
import map from "./partials/map";
import relatedItems from "./partials/related-items";
import sideNav from "./partials/side-nav";
import officesMap from "./partials/offices-map";
import video from "./partials/video";
import accordion from "./partials/accordion";
import tables from "./partials/tables";
import equalHeight from "./partials/equal-height";
import homeModalVideo from "./partials/home-modal-video";

navigation();
content();
heroFade();
formatHeroTagline();
search();
controls();
map();
relatedItems();
sideNav();
officesMap();
video();
accordion();
tables();
equalHeight();
homeModalVideo();



// WEBPACK FOOTER //
// ./src/js/index.js